import React, { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../../constants/url';
import HeadSub from '../../../components/comm/HeadSub';
import ToastPopup from '../../../components/comm/ToastPopup';
import style from './PrescriptionCode.module.css';

const PrescriptionCode = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state || {};

    const inputRef = useRef(null);
    const [code, setCode] = useState('');
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [lineActive, setLineActive] = useState(false);

    const isValid = code.length === 6;

    const handleChange = (e) => {
        const val = e.target.value.replace(/\D/g, '').slice(0, 6);
        setCode(val);
    };

    const handleClear = () => {
        setCode('');
        inputRef.current?.focus();
    };

    const handleSubmit = () => {
        if (!isValid) return;

        // ※ 서버연결전 비활성화 — Mock 검증
        if (code === '123456') {
            navigate(URL.IDENTITY, { state: { returnPath: '/sign-up'} });
        } else {
            setToastMessage('인증코드가 올바르지 않습니다.');
            setToast(true);
        }
    };

    return (
        <>
            <HeadSub title="인증코드 인증" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-padding="30">

                    <div className={style.contentBox}>
                        <p className={style.subtitle}>WellBe 서비스 이용을 위해</p>
                        <strong className={style.title}>인증코드가 필요합니다.</strong>

                        <div className={style.inputWrap}>
                            <div className={style.inputBox}>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    maxLength={6}
                                    // placeholder="인증코드 6자리를 입력해주세요."
                                    placeholder="임시 123456"
                                    value={code}
                                    onChange={handleChange}
                                    onFocus={() => setLineActive(true)}
                                    onBlur={() => setLineActive(false)}
                                    onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
                                />
                                {code.length > 0 && (
                                    <button className={style.clearBtn} onClick={handleClear} type="button">
                                        <span className="blind">지우기</span>
                                    </button>
                                )}
                                <span className={style.line} data-active={lineActive || code.length > 0 ? 'on' : 'off'} />
                            </div>
                        </div>
                    </div>

                    {/* 하단 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    disabled={!isValid}
                                    onClick={handleSubmit}
                                >
                                    <span>다음</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {toast && (
                        <ToastPopup setToast={setToast} message={toastMessage} position="center" />
                    )}
                </div>
            </div>
        </>
    );
};

export default PrescriptionCode;